<template>
  <div class="color-simple" :class="{ [type]: type }" :style="{ width }">
    <div class="color-simple-color" :style="backgroundImage"></div>
    <div class="_title">{{ unit }}</div>

    <div class="color-simple-value">
      <div v-for="(item, index) in orderedData" :key="index">{{ item }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    unit: {
      type: String,
      default: 'm/s'
    },
    colors: {
      type: Array,
      default: () => []
    },
    values: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: () => 'vertical'
    },
    width: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  computed: {
    orderedData() {
      if (this.type === 'vertical') {
        const data = [...this.values];
        return data.reverse();
      }
      return this.values;
    },
    backgroundImage() {
      const indent = Math.round(100 / this.colors.length);
      const arr = this.colors.map((color, i) => `${color} ${i * indent}%`);
      const angle = this.type === 'horizontal' ? '90deg' : '0deg';
      return `background-image: linear-gradient(${angle}, ${arr.join(',')});`;
    }
  }
};
</script>

<style lang="less" scoped>
._title {
  color: #888;
  margin-top: 5px;
  text-indent: 8px;
}
.color-simple {
  position: relative;
  box-sizing: border-box;
  color: @black-color;
  font-size: 12px;
  padding: 8px;
  padding-bottom: 20px;
  width: 100%;
  height: 100%;

  &.vertical {
    .title {
      font-size: 8px;
      text-align: center;
    }

    .color-simple-color {
      width: 35px;
      height: 100%;
      margin-left: 6px;
      border-radius: 8px;
    }

    .color-simple-value {
      //font-size: 8px;
      color: @black-color;
      position: absolute;
      width: 30px;
      top: 8px;
      bottom: 20px;
      right: 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }

  &.horizontal {
    min-width: 300px;
    height: 50px;

    ._title {
      position: absolute;
      right: 10px;
      top: 5px;
      color: @black-color;
    }

    .color-simple-color {
      margin-right: 30px;
      height: 20px;
    }

    .color-simple-value {
      width: 100%;
      position: relative;
      display: flex;
      color: @black-color;
      margin-left: -14px;
      text-align: center;
      > div {
        flex: 1;
      }
    }
  }
}
</style>
